// Display helpers shared by the company page tabs.

export const UNIT_DIVISORS = { K: 1 / 1000, MM: 1, B: 1000 }; // base data is in $ millions
export const UNIT_DECIMALS = { K: 0, MM: 1, B: 2 };

const group = (n, d) =>
  Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export function fmtNumber(n, d = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return n < 0 ? `(${group(n, d)})` : group(n, d);
}

// kind: money | ps | pct | x | count
export function fmtCell(value, kind, unit = "MM") {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  switch (kind) {
    case "money":
      return fmtNumber(value / UNIT_DIVISORS[unit], UNIT_DECIMALS[unit]);
    case "ps":
      return fmtNumber(value, 2);
    case "pct":
      return value < 0 ? `(${group(value, 1)}%)` : `${group(value, 1)}%`;
    case "x":
      return `${fmtNumber(value, 2)}x`;
    case "count":
      return fmtNumber(value, 1);
    default:
      return fmtNumber(value, 2);
  }
}

export const fmtPct = (n, d = 1, sign = false) =>
  n === null || n === undefined || Number.isNaN(n)
    ? "—"
    : `${sign && n > 0 ? "+" : ""}${n < 0 ? "-" : ""}${group(n, d)}%`;

export const fmtMoney = (n, d = 2) =>
  n === null || n === undefined || Number.isNaN(n) ? "—" : `${n < 0 ? "-" : ""}$${group(n, d)}`;

export function fmtDate(d) {
  const x = new Date(d);
  return `${x.getMonth() + 1}/${x.getDate()}/${String(x.getFullYear()).slice(2)}`;
}

export function fmtLongDate(d) {
  return new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

export const fmtShortDate = (d) =>
  new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export function downloadCsv(filename, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const blob = new Blob([rows.map((r) => r.map(esc).join(",")).join("\n")], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
